export class NeoCalcularCuota {
  constructor(
    public tasafinalEA: Number,
    public monto: Number,
    public plazo: Number,
    public periodicidad: Number
  ) {}
}